// extracted by mini-css-extract-plugin
export default {"list":"index_list_9-Nxy","time":"index_time_PqmoV","green":"index_green_objeq","more":"index_more_Lx-y-","empty":"index_empty_0JfBL"};